<template>
  <div class="wrap qualifications">
    <div class="titleD">
      <div class="titleDT">{{slaveTitleX}}</div>
      <div>
        <h4 class="titlex">{{slaveTitle}}</h4>
        <h2 class="title">{{title}}</h2>
      </div>
    </div>
    <div class="xian"></div>
    <p class="introduce">{{introduce}}</p>
    <div class="center wrapW">
      <swiper :options="swiperOption" class="banner_list">
        <swiper-slide class="swiperL" v-for="(item,index) in list" :key="index">
          <img :src="item.img" :alt="item.name">
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev ip1 iconfont icon-zuojiantou_huaban" slot="button-prev"></div>
      <div class="swiper-button-next ip1 iconfont icon-right-arrow-1" slot="button-next"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'qualifications',
  data () {
    return {
      list: [],
      title: '',
      slaveTitleX: '',
      slaveTitle: '',
      introduce: '',
      swiperOption: {
        loop: true,
        nextButton: '.swiper-button-next.ip1',
        prevButton: '.swiper-button-prev.ip1',
        slidesPerView: 4,
        spaceBetween: 35,
        autoplay: 2000
      }
    }
  },
  mounted () {
    this.getAptitude()
  },
  methods: {
    getAptitude () {
      let that = this
      this.$axios.get(process.env.API_HOSTT + '/os/getAptitude', {
      }).then(
        function (res) {
          res = res.data.data
          that.list = res.list
          that.title = res.introduce.title
          that.introduce = res.introduce.desc
          that.slaveTitle = res.introduce.slaveTitle.substr(1)
          that.slaveTitleX = res.introduce.slaveTitle.substr(0,1)
        }
      ).catch(error => console.log(error))
    }
  }
}
</script>
<style lang="stylus" scoped>
.qualifications
  padding .66rem 0
  background-image url('~@/assets/img/qualifications.png')
  background-size 100% 100%
  background-repeat no-repeat
  .titleDT,.titlex,.title
    color #fff
  .xian,.xian::after, .xian::before
    background #fff
  .introduce
    width 100%
    font-size .16rem
    line-height .2rem
    color #fff
    margin-top .28rem
  .center
    margin-top .5rem
    max-width 1540px
    position relative
    .banner_list
      width 78%
      margin 0 auto
      padding .2rem 0
      overflow hidden !important
    .swiperL
      text-align left
      position relative
      img
        width 100%
    .ip1
      width 11%
      height 100%
      top 0
      margin-top 0px
      font-size .38rem
      color #c6c7c9
      opacity 0.4
      display flex
      align-items center
      justify-content center
    .ip1:hover
      opacity 1
    .swiper-button-prev
      left 0%
      background-image none
    .swiper-button-next
      right 0%
      background-image none
    .swiper-button-disabled
      opacity 0
    .swiper-container
      overflow initial
</style>



// WEBPACK FOOTER //
// src/pages/index/components/qualifications.vue